import { Component, OnInit } from '@angular/core';
import { JhiLanguageService } from '../../shared/core-utils';
import { ParamContext } from '../../shared/service/param.context';
import { TranslateService } from '@ngx-translate/core';
import { StudyService } from '../../shared/study/service/study.service';
import { CREATE_STUDIES_PERMISSIONS, STUDY_FOLDER_ACTIONS_CHANGE_PERMISSION } from '../../shared/auth/permissions';
import { BasicDetails } from '../tabs/basic-details/basic-details.model';
import { Principal } from '../../shared';
import { StudyType } from '../../shared/model/study-type.model';
import { StudyManagerTreeComponent } from '../../study-manager/study-manager-tree.component';
import { NgbActiveModal, NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../../shared/alert/alert.service';
import { CreateStudyRequest } from '../../shared/study/model/create-study-request.model';
import { DateHelperService } from '../../shared/service/date.helper.service';
import { Router } from '@angular/router';
import { StudyEditorService } from '../study-editor.service';
import { StudyDetails } from '../../shared/study/model/study-details.model';
import { VariableTypeEnum } from '../../shared/ontology/variable-type.enum';
import { ObservationVariable } from '../../shared/model/observation-variable.model';
import { VariableUtilityService } from '../shared/services/variable-utility.service';
import { DatasetTypeEnum } from '../../shared/dataset/model/dataset-type.enum';
import { DatasetService } from '../../shared/dataset/service/dataset.service';
import { HELP_MANAGE_STUDIES } from '../../app.constants';

@Component({
    selector: 'jhi-create-study',
    templateUrl: './create-study.component.html',
    styleUrl: './create-study.component.scss'
})
export class CreateStudyComponent implements OnInit {

    protected readonly CREATE_STUDIES_PERMISSIONS = CREATE_STUDIES_PERMISSIONS;
    protected readonly STUDY_FOLDER_ACTIONS_CHANGE_PERMISSIONS = STUDY_FOLDER_ACTIONS_CHANGE_PERMISSION;
    protected readonly VariableTypeEnum = VariableTypeEnum;
    protected readonly HELP_MANAGE_STUDIES = HELP_MANAGE_STUDIES;

    basicDetails: BasicDetails = new BasicDetails();
    helpLink: string;
    studyTypes: StudyType[];
    useTemplate: boolean = false;
    templateStudyId: number;
    templateStudyName: string;
    templateStudyDetails: StudyDetails;
    proceedToSave: boolean = false;
    user: any;

    displayedStudySettings: ObservationVariable[];
    displayedEnvironmentConditions: ObservationVariable[];
    displayedEnvironmentDetails: ObservationVariable[];
    displayedTraits: ObservationVariable[];
    displayedSelections: ObservationVariable[];

    isTemplateStudyLoading: boolean = false;
    isSaving: boolean = false;

    constructor(private paramContext: ParamContext,
                public translateService: TranslateService,
                private router: Router,
                private principal: Principal,
                private modalService: NgbModal,
                private activeModal: NgbActiveModal,
                private studyService: StudyService,
                private alertService: AlertService,
                public dateHelperService: DateHelperService,
                private studyEditorService: StudyEditorService,
                private variableUtilityService: VariableUtilityService,
                private datasetService: DatasetService,
                private languageService: JhiLanguageService
    ) {
    }

    async ngOnInit() {
        const currentLang = this.languageService.getCurrentLanguage();
        this.languageService.changeLanguage(currentLang);
        this.paramContext.readParams();
        this.user = await this.principal.identity();
        this.basicDetails.startDate = NgbDate.from({
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1,
            day: new Date().getDate()
        });
        console.warn('hey');
        this.studyTypes = await this.studyService.getStudyTypes(this.paramContext.cropName, this.paramContext.programUUID).toPromise()
            .then(studyTypes => {
                return studyTypes.map(st => ({
                    ...st,
                    label: 'study-editor.study-type.' + st.label.toLowerCase().trim().replace(/ /g, '.')
                }));
            });
    }

    hasAnyAuthority(permissions: string[]) {
        return this.principal.hasAnyAuthority(permissions);
    }

    changeFolderLocation() {
        const modalRef = this.modalService.open(StudyManagerTreeComponent, {
            modalDialogClass: 'modal-md',
            backdrop: 'static'
        });
        modalRef.componentInstance.selectionMode = 'single';
        modalRef.componentInstance.isFolderSelectionMode = true;
        modalRef.componentInstance.hideViewSummaryButton = true;
        modalRef.componentInstance.showOpenFolderButton = true;
        modalRef.componentInstance.openFolderButtonKey = 'entity.action.select';
        modalRef.result.then((studies) => {
            if (studies && studies.length === 1) {
                this.basicDetails.parentFolderName = studies[0].name;
                this.basicDetails.parentFolderId = studies[0].id;
            }
            this.activeModal.close();
            if (this.proceedToSave) {
                this.save();
            }
        }, () => {
            this.proceedToSave = false;
        });

    }

    openTemplateDialog() {
        const modalRef = this.modalService.open(StudyManagerTreeComponent, {
            modalDialogClass: 'modal-md',
            backdrop: 'static'
        });
        modalRef.componentInstance.selectionMode = 'single';
        modalRef.componentInstance.isFolderSelectionMode = false;
        modalRef.componentInstance.hideViewSummaryButton = true;
        modalRef.componentInstance.showOpenFolderButton = false;
        modalRef.componentInstance.openFolderButtonKey = 'entity.action.select';
        modalRef.result.then((studies) => {
            if (studies && studies.length === 1) {
                this.templateStudyId = studies[0].id;
                this.templateStudyName = studies[0].name;
                this.loadTemplateStudy(this.templateStudyId);
            }
            this.activeModal.close();
        }, () => {
        });
    }

    createStudy() {

        if (!this.basicDetails.parentFolderId) {
            this.changeFolderLocation();
            this.proceedToSave = true;
            return;
        }

        this.save();

    }

    save() {

        if (this.isFormValid()) {
            this.isSaving = true;
            const request: CreateStudyRequest = {
                name: this.basicDetails.name,
                description: this.basicDetails.description,
                studyType: this.basicDetails.studyType,
                objective: this.basicDetails.objective,
                createdByName: this.basicDetails.createdByName,
                startDate: this.basicDetails.startDate ? this.dateHelperService.convertNgbDateToString(this.basicDetails.startDate) : null,
                endDate: this.basicDetails.endDate ? this.dateHelperService.convertNgbDateToString(this.basicDetails.endDate) : null,
                parentFolderId: this.basicDetails.parentFolderId,
                studySettings: this.templateStudyDetails?.studySettings,
                environmentDetails: this.templateStudyDetails?.environmentDetails,
                environmentConditions: this.templateStudyDetails?.environmentConditions,
                traits: this.displayedTraits,
                selections: this.templateStudyDetails?.selections,
                entryDetails: this.templateStudyDetails?.entryDetails,
                templateStudyId: this.templateStudyId,
            };

            // If validation passes, proceed with study creation
            this.studyService.createStudy(request).toPromise().then(response => {
                this.studyEditorService.navigateToTab(response.body.id, 'study-settings');
                this.alertService.success('study-editor.create-study.success');
            }).finally(() => {
                this.isSaving = false;
            });
        }
    }

    cancel() {
        this.router.navigate(['/study-manager/study-search'], { queryParamsHandling: 'merge' });
    }

    isFormValid(): boolean {

        // Validate required fields
        const validationErrors: string[] = [];

        if (!this.basicDetails.name?.trim()) {
            validationErrors.push(this.translateService.instant('study-editor.validation.name-required'));
        }

        if (!this.basicDetails.description?.trim()) {
            validationErrors.push(this.translateService.instant('study-editor.validation.description-required'));
        }

        if ((this.basicDetails?.name && this.validateValue(this.basicDetails.name))
            || (this.basicDetails?.description && this.validateValue(this.basicDetails.description))) {
            validationErrors.push(this.translateService.instant('study-editor.study-dataset.error.name.description.invalid-value'));
        }

        if (!this.basicDetails.studyType) {
            validationErrors.push(this.translateService.instant('study-editor.validation.study-type-required'));
        }

        if (!this.basicDetails.startDate) {
            validationErrors.push(this.translateService.instant('study-editor.validation.creation-date-required'));
        }

        if (!this.dateHelperService.isNgbDateValid(this.basicDetails.startDate)) {
            validationErrors.push(this.translateService.instant('study-editor.validation.creation-date-invalid'));
        }

        if (this.basicDetails.endDate && !this.dateHelperService.isNgbDateValid(this.basicDetails.endDate)) {
            validationErrors.push(this.translateService.instant('study-editor.validation.completion-date-invalid'));
        }

        // Check max length for name and description
        if (this.basicDetails.name?.trim() && this.basicDetails.name.length > 225) {
            validationErrors.push(this.translateService.instant('study-editor.validation.name-too-long'));
        }

        if (this.basicDetails.description?.trim() && this.basicDetails.description.length > 225) {
            validationErrors.push(this.translateService.instant('study-editor.validation.description-too-long'));
        }

        if (this.basicDetails?.objective && this.validateValue(this.basicDetails.objective)) {
            validationErrors.push(this.translateService.instant('study-editor.study-dataset.error.objective.invalid-value'));
        }

        if (validationErrors.length > 0) {
            // Join all validation messages with line breaks
            const errorMessage = validationErrors.join('<br>');
            this.alertService.error('error.custom', { param: errorMessage, escapeHtml: false });
            return false;
        }

        return true;
    }

    async loadTemplateStudy(studyId: number) {
        this.isTemplateStudyLoading = true;
        try {
            const templateStudyResponse = await this.studyService.getStudyDetails(studyId).toPromise();
            if (templateStudyResponse && templateStudyResponse.body) {
                this.templateStudyDetails = templateStudyResponse.body;
                this.displayedStudySettings = this.variableUtilityService.consolidatePairVariables(this.templateStudyDetails.studySettings);
                this.displayedEnvironmentDetails = this.variableUtilityService.consolidatePairVariables(this.templateStudyDetails.environmentDetails);
                this.displayedEnvironmentConditions = this.templateStudyDetails.environmentConditions;
                this.displayedTraits = await this.getTraits(studyId);
                this.displayedSelections = this.templateStudyDetails.selections;
            }
        } catch {
            this.alertService.error('error.general');
        } finally {
            this.isTemplateStudyLoading = false;
        }
    }

    useTemplateChanged(useTemplate: boolean) {
        if (!useTemplate) {
            this.templateStudyId = null;
            this.templateStudyDetails = null;
        }
    }

    private validateValue(value) {
        const invalidChars = /[<>?|%]/;
        return invalidChars.test(value);
    }

    async getTraits(studyId: number) {
        const datasetsResponse = await this.datasetService.getDatasets(studyId, [DatasetTypeEnum.PLOT]).toPromise();
        if (datasetsResponse.body && datasetsResponse.body.length > 0 && datasetsResponse.body[0].datasetTypeId === DatasetTypeEnum.PLOT) {
            return datasetsResponse.body[0].variables.filter((variable: ObservationVariable) => variable.variableType?.toString() === VariableTypeEnum[VariableTypeEnum.TRAIT]);
        }
        return [];
    }
}
